import config from 'configDir/index';
import { get } from './http';

const baseUrl = '/vehicle';
const { resourceUrl } = config;

//  根据类型，关键字搜索车辆
const searchVehicleService = get(`${baseUrl}/searchVehicle`, resourceUrl);
const queryBindVehicleService = get(`${baseUrl}/vehicleBindRoute`, resourceUrl);

export {
  // eslint-disable-next-line import/prefer-default-export
  searchVehicleService,
  queryBindVehicleService,
};
